import api from "./Api";

class RegraComissaoVendedorService {
  GetRegraComissaoVendedor(payload) {
    return api.get("/v1/regraComissaoVendedor/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRegraComissaoVendedor(payload) {
    return api.post("/v1/regraComissaoVendedor/", payload).then((response) => {
      return response.data;
    });
  }

  PutRegraComissaoVendedor(payload) {
    return api.put("/v1/regraComissaoVendedor/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRegraComissaoVendedor(payload) {
    return api
      .delete("/v1/regraComissaoVendedor/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRegraComissaoVendedorOData(payload) {
    return api
      .get("/OData/RegraComissaoVendedor" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new RegraComissaoVendedorService();
